// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3_k_n","inputWrap":"CustomTip_inputWrap__2hDC7"};